const NAME = "HISTORICAL_DISTRIBUTION_COST";

export default NAME;
